import Button from './ui/Button';
import Select from './ui/Select';

function buildPaginationItems(currentPage, totalPages) {
    if (totalPages <= 7) {
        return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const items = [1];
    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    if (start > 2) {
        items.push('ellipsis-start');
    }

    for (let page = start; page <= end; page++) {
        items.push(page);
    }

    if (end < totalPages - 1) {
        items.push('ellipsis-end');
    }

    items.push(totalPages);
    return items;
}

const PaginationControls = ({
    currentPage,
    totalPages,
    onPageChange,
    itemsPerPage,
    onItemsPerPageChange,
    totalItems,
    className = '',
}) => {
    const safeTotalPages = Math.max(1, Number(totalPages || 1));
    const safeCurrentPage = Math.min(Math.max(1, Number(currentPage || 1)), safeTotalPages);
    const pageItems = buildPaginationItems(safeCurrentPage, safeTotalPages);

    return (
        <div className={`flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between ${className}`.trim()}>
            <div className="flex items-center gap-2">
                <span className="text-sm text-mono-600 dark:text-mono-400">Mostrar</span>
                <Select
                    value={itemsPerPage}
                    onChange={(event) => onItemsPerPageChange(Number(event.target.value))}
                    className="w-24 px-2 py-1 text-sm"
                >
                    <option value={15}>15</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </Select>
                <span className="text-sm text-mono-600 dark:text-mono-400">de {totalItems}</span>
            </div>
            <div className="flex items-center gap-1">
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => onPageChange(Math.max(1, safeCurrentPage - 1))}
                    disabled={safeCurrentPage <= 1}
                >
                    Anterior
                </Button>
                {pageItems.map((page, index) => {
                    if (typeof page !== 'number') {
                        return (
                            <span
                                key={`${page}-${index}`}
                                className="px-2 py-1 text-sm text-mono-500 dark:text-mono-500"
                            >
                                ...
                            </span>
                        );
                    }

                    return (
                        <button
                            key={page}
                            type="button"
                            onClick={() => onPageChange(page)}
                            className={`min-w-[32px] rounded-lg border px-2 py-1.5 text-sm font-medium transition-colors ${
                                safeCurrentPage === page
                                    ? 'border-black bg-black text-white dark:border-white dark:bg-white dark:text-black'
                                    : 'border-mono-300 bg-white text-mono-700 hover:bg-mono-50 dark:border-mono-700 dark:bg-black dark:text-mono-300 dark:hover:bg-mono-900'
                            }`}
                        >
                            {page}
                        </button>
                    );
                })}
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => onPageChange(Math.min(safeTotalPages, safeCurrentPage + 1))}
                    disabled={safeCurrentPage >= safeTotalPages}
                >
                    Proxima
                </Button>
            </div>
        </div>
    );
};

export default PaginationControls;
